import { observer } from 'mobx-react-lite'
import useStore from 'reusable/mobx-store-utils'
import ServerReachabilityNotifier from './ServerReachabilityNotifier'
import { serverReachabilityStore } from './ServerReachabilityStore'

export default observer(function ServerReachabilityNotice() {
   useStore(() => new ServerReachabilityNotifier({ reachabilityStore: serverReachabilityStore }))
   return null
})
